class TextHelper {
  // Artificially separate text in paragraphs if it has any.
  // Sometimes the split results in empty paragraphs, so we need to
  // remove those.
  static separateIntoParagraphs(text = '', removeBlankParagraphs = true) {
    let split = text.split('\r\n');
    if (removeBlankParagraphs) {
      split = split.filter(Boolean);
    }
    return split;
  }
}

export { TextHelper };



// WEBPACK FOOTER //
// ./src/helpers/TextHelper.js